
<ScrollContainer>
  <EditForm
    :roles="roles"
    :entities="entities"
    :user-data="user"
    :on-cancel="handleFormCancel"
    @created="handleCreate"
    @updated="handleUpdate"
  />
</ScrollContainer>
